/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Typography2 } from '@coursera/cds-core';

import { getInitialsFromFullName } from 'bundles/common/utils/commonUtils';

import _t from 'i18n!nls/enterprise-ui';

/**
 * @deprecated use CDS Avatar instead
 */
export const Avatar = ({
  style = {},
  imgSrc,
  fullName,
  size = 38,
}: {
  style?: React.CSSProperties;
  imgSrc?: string;
  fullName?: string;
  size?: number;
}) => {
  const getBackgroundColor = () => {
    if (fullName && fullName.length > 0) {
      // Using the last letter so that people with the same first name get different colors
      const colorCode = fullName.charCodeAt(fullName.length - 1) % 3;
      if (colorCode === 0) {
        return 'var(--cds-color-purple-950)';
      } else if (colorCode === 1) {
        return 'var(--cds-color-green-700)';
      } else {
        return 'var(--cds-color-blue-700)';
      }
    }
    return 'var(--cds-color-grey-50)';
  };

  const commonStyles = css({
    color: 'var(--cds-color-white-0)',
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    overflow: 'hidden',
    objectFit: 'cover',
  });

  const dynamicStyles: React.CSSProperties = {
    backgroundColor: getBackgroundColor(),
    fontSize: size / 2,
    height: size,
    width: size,
    minWidth: size,
  };
  const mergedStyles: React.CSSProperties = { ...dynamicStyles, ...style };

  if (imgSrc) {
    return (
      <Imgix
        alt={fullName ?? _t('Profile photo')}
        css={commonStyles}
        style={mergedStyles}
        src={imgSrc}
        role="presentation"
      />
    );
  }
  return (
    <div css={commonStyles} style={mergedStyles}>
      <Typography2 component="h4" variant="subtitleMedium" color="invertBody">
        {getInitialsFromFullName(fullName ?? '')}
      </Typography2>
    </div>
  );
};
